export enum ChatSearchSortOrder {
  NEWEST = 'newest',
  OLDEST = 'oldest',
}
